export const inform = {
    path: '/inform',
    name: 'inform',
    title: '通知公告',
    component: () => import("../components/page/homePage/inform"),
    meta:{title:'通知公告'},
}


// WEBPACK FOOTER //
// ./src/router/inform.js